// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".site__footer-logo{align-items:center;display:inline-flex;padding:3px 6px;text-decoration:none}.site__footer-logo:focus,.site__footer-logo:hover{transform:scale(1.02)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
